@if (showLoader) {
  <div class="loader-container">
    <app-main-loader-lottie></app-main-loader-lottie>
  </div>
}

@if (!showLoader) {
  <div cdkDropList class="rules-list" (cdkDropListDropped)="onDroped($event)" (click)="onRuleClick($event)">
    @for (item of items; track item) {
      <div [id]="item.id" class="rule-box" cdkDrag>
        <div class="params">
          @if (item.internalName && item.conditionText && item.actionText) {
            <div>
              <span>
                <b>{{ item.internalName }}</b>
              </span>
            </div>
          }
          @if (item.conditionText && item.actionText) {
            <div class="condition">
              <span>
                {{ getConditionTitle() }}, <b>IF </b>
                <span [innerHTML]="getConditionText(item)"></span>
              </span>
            </div>
          }
          @if (item.conditionText && item.actionText) {
            <div class="action">
              <span>
                <b>THEN </b>
                <span [innerHTML]="getActionText(item)"></span>
                @if (item.actionName == RulesActions.ColorCoding) {
                  <span>
                    @for (color of item.actionValue.colors; track color) {
                      <pdq-color-tag class="action-value-color-tag" [color]="color"></pdq-color-tag>
                    }
                  </span>
                }
              </span>
            </div>
          }
          @if (!item.conditionText || !item.actionText) {
            <div class="inactive-alert">This Quickflow has been made inactive, edit or delete it.</div>
          }
        </div>
        <div class="actions-wrapper">
          <div class="actions">
            <pdq-slide-toggle
              [defaultValue]="!!item.enabled"
              (onToggle)="onRuleToggleHandler($event, item.id)"
              (click)="$event.stopPropagation()"></pdq-slide-toggle>
            <button
              class="menu-btn"
              mat-icon-button
              [matMenuTriggerFor]="actionsMenu"
              (click)="$event.stopPropagation()">
              <img src="assets/icons/icon-three-dots-black.svg" />
            </button>
            <mat-menu class="rule-actions-menu" #actionsMenu="matMenu">
              <button (click)="onEditRuleHandler(item.id)" mat-menu-item>
                <span>Edit</span>
              </button>
              <button (click)="onDuplicateRuleHandler(item.id)" mat-menu-item>
                <span>Duplicate</span>
              </button>
              <button (click)="onDeleteRuleHandler(item.id)" mat-menu-item>
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
          <div class="updated-at">Updated {{ getTimeFromNow(item.updatedAt) }}</div>
        </div>
      </div>
    }
  </div>
}
